define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    exports["default"] = {
        pink: '#e5b2b6',
        red: '#b1362f',
        orange: '#ea8825',
        gold: '#fae485',
        yellow: '#f0f04f',
        green: '#2e6020',
        blue: '#1f2294',
        purple: '#824ed2',
        white: '#fff',
        beige: '#f6f5f4',
        grey: '#d4d4dc',
        black: '#000',
        brown: '#654320'
    };
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/colorTable.js
// module id = 25
// module chunks = 0